import { jsx } from "react/jsx-runtime";
import React__default from "react";
import AntCol from "antd/es/grid/col";
import classnames from "../../utils/classnames.js";
import './Grid.css';/* empty css          */
const Col = React__default.forwardRef(function Col2({ className, children, background = "default", ...props }, ref) {
  return /* @__PURE__ */ jsx(
    AntCol,
    {
      className: classnames(
        [
          "perxis-auto-col",
          {
            [`perxis-auto-col-background-${background}`]: background !== "default"
          }
        ],
        className
      ),
      ref,
      ...props,
      children
    }
  );
});
export {
  Col as default
};
//# sourceMappingURL=Col.js.map
